import { render, staticRenderFns } from "./StudentUpload.vue?vue&type=template&id=7adb746b&scoped=true"
import script from "./StudentUpload.vue?vue&type=script&lang=js"
export * from "./StudentUpload.vue?vue&type=script&lang=js"
import style0 from "./StudentUpload.vue?vue&type=style&index=0&id=7adb746b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7adb746b",
  null
  
)

export default component.exports